import { ContractConst } from '@blcloud/bl-datamodel/const/contract';
import { RoleConst } from '@blcloud/bl-datamodel/const/role';
import { ProductCode } from '@blcloud/bl-datamodel/enum/common/product-code';
import { PageId } from '@blcloud/bl-ng-share-module';
import {
  CarSalesEstimatesSlipDiv,
  CarSalesSlipOrderDiv,
  RepairEstimatesSlipDiv,
  RepairInstructionsSlipDiv,
  RepairSalesSlipDiv,
  SETTING_PATH,
  SLIP_NAVIGATION_PROPERTY,
  SfEstimatesSlipDiv,
  SfInstructionsSlipDiv,
  SfSalesSlipDiv,
} from '../../feature/biz-menu-page-screen-action-setting-modal/biz-menu-page-screen-action-setting-modal.define';
import { SlipKind } from '@blcloud/bl-datamodel/enum/sales/slip-kind';
import { SfSlipKind } from '@blcloud/bl-datamodel/enum/sales/sf-slip-kind';
import { Const } from '@blcloud/bl-common';
import { PagePath } from '@blcloud/bl-ng-menu-common-module';
import { BizMenuTabOption } from './biz-menu-page.interface';
import { BusinessMenuStatus } from '@blcloud/bl-datamodel/enum/bizcmn/business-menu-status';
import { BlTabStyle } from '@blcloud/bl-ng-ui-component';

/**
 * 入金伝票登録画面 画面タイプ定義
 */
export const DepositScreenType = {
  Deposit: { code: '1', name: '入金伝票(入金型)' },
  SlipAllocation: { code: '2', name: '入金伝票(伝票消込型)' }
};

/**
 * 出金伝票登録画面 画面タイプ定義
 */
export const PaymentScreenType = {
  Payment: { code: '1', name: '出金伝票(出金型)' },
  SlipAllocation: { code: '2', name: '出金伝票(伝票消込型)' }
};

export const BiTaskRunStatus = {
  None: { code: '0', name: '未実行' },
  Waiting: { code: '1', name: '実行待ち' },
  Starting: { code: '2', name: '実行開始' },
  Running: { code: '3', name: '実行中' },
  Finished: { code: '4', name: '実行終了' }
};

export const BiToolDetailAnalysisService = [
  /** デイリー */
  ContractConst.SERVICEID_OPT_CMN_BI_TOOL_DAILY,
  /** 年間サマリー */
  ContractConst.SERVICEID_OPT_CMN_BI_TOOL_YEARLY,
  /** 顧客車両分析 */
  ContractConst.SERVICEID_OPT_CMN_BI_TOOL_CUSTOMER,
  /** アプローチ */
  ContractConst.SERVICEID_OPT_CMN_BI_TOOL_APPROACH,
  /** 入庫管理 */
  ContractConst.SERVICEID_OPT_CMN_BI_TOOL_INCOMING,
  /** 入金売掛 */
  ContractConst.SERVICEID_OPT_CMN_BI_TOOL_CREDIT,
  /** 車両販売 */
  ContractConst.SERVICEID_OPT_CMN_BI_TOOL_CARSALES
];

/**
 * ローカルストレージKey
 */
export const LocalStorageKey = {
  /** 入金伝票画面タイプ */
  DepositScreenType: 'depositScreenType',
  /** 出金伝票画面タイプ */
  PaymentScreenType: 'paymentScreenType',
  /** ログイン後初回フラグ */
  InitAfterLogin: 'initAfterLogin',
};

/** 受発注タブの項目ID */
export const BlPartsOrderMenuContentId = {
  /** 決済確認 */
  PayConfirm: 4,
  /** カート */
  Cart: 6,
  /** お気に入り */
  Favorite: 8,
  /** チャット */
  Chat: 9,
} ;

/**
 * メンテナンス管理画面などの各種タブを識別するためのID定義
 */
export const MaintenanceTabId = {
  /** 整備タブ */
  SuperFrontman: '1',
  /** 鈑金タブ*/
  Repair: '3',
  /** 車販タブ(見積注文OP) */
  CarSales: '15',
  /** 車販タブ(仕入OP) */
  VehiclePurchase: '29',
  /** 一新多助（オプションによる個別タブ） */
  IsshinTasuke: 'IsshinTasuke',
};

/**
 * 特定の処理を許可する、アクティブなタブのIDリストです
 */
export const ACTIVE_TAB_IDS = [
  MaintenanceTabId.SuperFrontman,
  MaintenanceTabId.Repair,
  MaintenanceTabId.CarSales,
  MaintenanceTabId.VehiclePurchase ,
];

/**
 * ボタン表示用のテキストを定義
 */
export const ButtonLabels = {
  TOGGLE_MENU_CUSTOM_SETTING: 'カスタム設定',
  DISPLAY_SETTING: '画面動作設定',
  ISSHIN_TASUKE_SETTING: '一新多助設定',
};

/**
 * バブルファンクションロール定義
 */
export enum BubbleFnRole {
  /** 画面動作設定 */
  ScreenActionSetting = 1000,
  /** 一新多助設定 */
  IsshinTasukeSetting = 2000,
}

/**
 * メンテナンス対象の画面IDリスト
 */
export const MAINTENANCE_TARGET_PAGE_IDS = [
  /** 整備 */
  PageId.MenuSfBiz,
  /** 鈑金 */
  PageId.MenuRepairBiz,
  /** 車販 */
  PageId.CarSales,
];

/**
 * 画面遷移ルールの定義
 * [productCode][navigationDiv] の形式でマッピングする
 */
export const NAVIGATION_RULES = {
  /** 整備 */
  [ProductCode.SuperFrontman]: {
    ['SfEstimatesSlipDiv.VehicleSearch']: `${Const.SpaRoot.MENU}${Const.RoutePath.CUSTOMER_VEHICLE_SEARCH}`,
    ['SfInstructionsSlipDiv.VehicleSearch']: `${Const.SpaRoot.MENU}${Const.RoutePath.CUSTOMER_VEHICLE_SEARCH}`,
    ['SfSalesSlipDiv.VehicleSearch']: `${Const.SpaRoot.MENU}${Const.RoutePath.CUSTOMER_VEHICLE_SEARCH}`,
  },
  /** 鈑金 */
  [ProductCode.Repair]: {
    ['RepairEstimatesSlipDiv.SalesSlipEntryCondition']: PagePath.RepairSlipEntryCondition,
    ['RepairInstructionsSlipDiv.SalesSlipEntryCondition']: PagePath.RepairSlipEntryCondition,
    ['RepairSalesSlipDiv.SalesSlipEntryCondition']: PagePath.RepairSlipEntryCondition,
  },
  /** 車販 */
  [ProductCode.CarSales]: {
    ['CarSalesEstimatesSlipDiv.EstimatesSlip']: PagePath.CarSalesSlipEntry,
    ['CarSalesSlipOrderDiv.VehicleSearch']: `${Const.SpaRoot.MENU}${Const.RoutePath.CUSTOMER_VEHICLE_SEARCH}`,
  }
};

/**
 * 画面遷移の判定ルールを定義するインターフェース
 */
export interface IDivLookupRule {
  /** チェック対象の screenActionSetting プロパティへのパス */
  settingProperty: string[];
  /** 期待される遷移先のDIV（画面識別子） */
  expectedDiv: {
    name: string;
    value: string;
  };
}

/**
 * プロダクトごと、伝票種別ごとの画面遷移判定ルールを格納する設定オブジェクト
 * 第一階層のキー：プロダクトコード (ProductCode)
 * 第二階層のキー：伝票種別 (SlipKind)
 * 値：判定ルール (IDivLookupRule)
 * この設定に基づき、動的に画面遷移先を決定します
 */
export const DIV_LOOKUP_CONFIG: Record<string, Record<string, IDivLookupRule>> = {
  /** 整備 */
  [ProductCode.SuperFrontman]: {
    [SlipKind.EstimatesSlip]: {
      // プロパティパスを配列で指定
      settingProperty: [SETTING_PATH.SF, SLIP_NAVIGATION_PROPERTY.ESTIMATES_SLIP],
      expectedDiv: {
        name: 'SfEstimatesSlipDiv.VehicleSearch',
        value: SfEstimatesSlipDiv.VehicleSearch
      }
    },
    [SfSlipKind.InstructionsSlip]: {
      settingProperty: [SETTING_PATH.SF, SLIP_NAVIGATION_PROPERTY.INSTRUCTIONS_SLIP],
      expectedDiv: {
        name: 'SfInstructionsSlipDiv.VehicleSearch',
        value: SfInstructionsSlipDiv.VehicleSearch
      }
    },
    [SlipKind.SalesSlip]: {
      settingProperty: [SETTING_PATH.SF, SLIP_NAVIGATION_PROPERTY.SALES_SLIP],
      expectedDiv: {
        name: 'SfSalesSlipDiv.VehicleSearch',
        value: SfSalesSlipDiv.VehicleSearch
      }
    },
  },
  /** 鈑金 */
  [ProductCode.Repair]: {
    [SlipKind.EstimatesSlip]: {
      // プロパティパスを配列で指定
      settingProperty: [SETTING_PATH.REPAIR, SLIP_NAVIGATION_PROPERTY.ESTIMATES_SLIP],
      expectedDiv: {
        name: 'RepairEstimatesSlipDiv.SalesSlipEntryCondition',
        value: RepairEstimatesSlipDiv.SalesSlipEntryCondition
      }
    },
    [SfSlipKind.InstructionsSlip]: {
      settingProperty: [SETTING_PATH.REPAIR, SLIP_NAVIGATION_PROPERTY.INSTRUCTIONS_SLIP],
      expectedDiv: {
        name: 'RepairInstructionsSlipDiv.SalesSlipEntryCondition',
        value: RepairInstructionsSlipDiv.SalesSlipEntryCondition
      }
    },
    [SlipKind.SalesSlip]: {
      settingProperty: [SETTING_PATH.REPAIR, SLIP_NAVIGATION_PROPERTY.SALES_SLIP],
      expectedDiv: {
        name: 'RepairSalesSlipDiv.SalesSlipEntryCondition',
        value: RepairSalesSlipDiv.SalesSlipEntryCondition
      }
    },
  },
  /** 車販 */
  [ProductCode.CarSales]: {
    [SlipKind.EstimatesSlip]: {
      // プロパティパスを配列で指定
      settingProperty: [SETTING_PATH.CAR_SALES, SLIP_NAVIGATION_PROPERTY.ESTIMATES_SLIP],
      expectedDiv: {
        name: 'CarSalesEstimatesSlipDiv.EstimatesSlip',
        value: CarSalesEstimatesSlipDiv.EstimatesSlip
      }
    },
    [SfSlipKind.InstructionsSlip]: {
      settingProperty: [SETTING_PATH.CAR_SALES, SLIP_NAVIGATION_PROPERTY.INSTRUCTIONS_SLIP],
      expectedDiv: {
        name: 'CarSalesSlipOrderDiv.VehicleSearch',
        value: CarSalesSlipOrderDiv.VehicleSearch
      }
    }
  },
};

// 伝票検索画面のURLパス
export const SLIP_SEARCH_URL_PATHS = {
  /** 整備、鈑金伝票検索 */
  SALESSLIP_SEARCH: '/menu/salesslip/search',
  /** 車両販売伝票検索 */
  CAR_SALES_SLIP_SEARCH: '/carsales/csslipsearch',
};

/**
 * 画面遷移ルール
 */
export interface TransitionRule {
  /** サービスIDリスト */
  serviceIds: string[];
  /** サービスIDに対応する利用不可権限一覧 */
  roleIds: string[];
  /** 権限不足時ダイアログ用の表示名 */
  permissionLabel: string;
}

/**
 * 整備、板金尿データ出力履歴遷移ルール
 */
export const SF_REPAIR_OUTPUT_HISTORY_TRANSITION_RULES: TransitionRule[] = [
  {
    serviceIds: [
      ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_VEHICLE_INSP_INVITATION,
      ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_CUST_VCLE_FREE_SEARCH,
      ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_PERIODIC_INSP_INVITATION,
      ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_COMPLETE_INVITATION,
      ContractConst.SERVICEID_OPT_MAC_DATA_OUTPUT_PRDC_EXCHG_LATER_DATE,
    ],
    roleIds: [RoleConst.ROLEID_MENU_ALL_DATA_OUTPUT],
    permissionLabel: '「データ出力メニューの使用」',
  },
  {
    serviceIds: [ContractConst.SERVICEID_OPT_CMN_CASE_EVIDENCE_AUTO_REGIST],
    roleIds: [RoleConst.ROLEID_FUNC_ALL_EVIDENCE_BULKDOWNLOAD],
    permissionLabel: '「証跡の一括ダウンロード」',
  },
];

/**
 * 鈑金の見積りサービスID(重鈑金、軽鈑金)
 */
export const REPAIR_SLIP_SERVICE_IDS = [
  /** サービスID 鈑金見積サービス */
  ContractConst.SERVICEID_OPT_RPC_REPAIR_ESTIMATE,
  /** サービスID 軽鈑金見積サービス */
  ContractConst.SERVICEID_OPT_RPC_LIGHT_REPAIR_ESTIMATE,
];

/**
 * 鈑金タブの受付アイコンの遷移先判定に必要なサービスID
 */
export const RECEPTION_ROUTE_SERVICE_IDS = [
  /** サービスID 顧客管理 */
  ContractConst.SERVICEID_OPT_CMN_CUSTOMER_MGT,
  /** サービスID 車両管理 */
  ContractConst.SERVICEID_OPT_CMN_VEHICLE_MGT,
];

export const MaintenanceRepairMenuContentId = {
  Reception: 1,
};

export const BusinessMenuGroupId = {
  /** 整備タブ */
  Maintenance: 1,
  /** 鈑金タブ */
  Repair: 3,
  /** 入金請求タブ */
  CreditTab: 4,
  /** 部品商タブ */
  PartsTabPartsman: 5,
  /** 在庫タブ(Pm.c) */
  StockTabPartsman: 7,
  /** 入金請求タブ(Pm.c) */
  CreditTabPartsman: 9,
  /** 出金支払タブ(Pm.c) */
  DebtTabPartsman: 10,
  /** 硝子タブ(Glass.c) */
  GlassTabGlass: 11,
  /** 実績タブ(Pm.c) */
  PerformanceTabPartsman: 12,
  /** 分析タブ(Glass.c) */
  AnalysisTabPartsman: 13,
  /** 在庫タブ(Recycle+) */
  StockTabRecycle: 16,
  /** 出金支払タブ(Recycle+) */
  DebtTabRecycle: 17,
  /** 入金請求タブ(Recycle+) */
  CreditTabRecycle: 18,
  /** 実績タブ(Glass) */
  GlassTabRecycle: 19,
  /** 入金請求タブ(Glass) */
  CreditTabGlass: 20,
  /** 実績タブ(Recycle+) */
  PerformanceTabRecycle: 21,
  /** 仕入在庫タブ */
  PurchaseTab: 25,
  /** 出金支払タブ(整備・鈑金) */
  DebtTabRepair: 26,
  /** 卸商検索(見積検索)タブ(Pm.c) */
  PmEstimateSearch: 27,
  /** 手形管理タブ(Pm.c) */
  PmBillMngTab: 28,
  /** 車販タブ(見積注文OP) */
  Carsales: 15,
  /** 車販タブ(仕入OP) */
  Vehiclepurchase: 29,
  /** 出金支払タブ(車販) */
  DebtTabCarsales: 30,
  /** プライスボードタブ */
  PricePrint: 31,
  /** 出金支払タブ(Glass) */
  DebtGlass: 45,
  /** BLPayタブ（取引先） */
  BLPaySuppliers: 40,
  /** BLPayタブ（加盟店） */
  BLPayAffiliated: 41,
  /** 受発注タブ */
  PartsOrder: 14,
  /** 共有車両在庫タブ */
  SharedVehicleStock: 46,
  /** 物流PFタブ */
  DeliveryPf: 50,
};

/**
 * 共有車両在庫の検討中件数を取得するときのページサイズ
 * （共有車両在庫検索APIの総件数のみを使うため、明細は最小件数で取得する）
 */
export const SharedVehicleStockConsiderationSearchPageSize = 1;

export const DiagnosisResultInfoState = {
  /** 読み込み中 */
  Reading: 0,
  /** 読み込み成功 */
  Success: 1,
  /** 読み込み失敗 */
  Fail: 2,
  /** データなし */
  NoData: 3
};

/**
 * 一新多助＋タブオプション
 */
export const IsshinTasukeTabOption: BizMenuTabOption = {
  tabId: MaintenanceTabId.IsshinTasuke,
  elementId: MaintenanceTabId.IsshinTasuke,
  label: '一新多助＋',
  classes: ['icon-icon_work'],
  serviceId: ContractConst.SERVICEID_OPT_CMN_TAJIMA,
  productCode: ContractConst.SERVICEID_OPT_CMN_TAJIMA,
  menuGroup: {
    businessMenuStatus: BusinessMenuStatus.Available
  },
  isShowDraftExplanatoryNote: false,
  isShowStayExplanatoryNote: false,
  isShowBlPayAffiliatedNote: false,
  isShowBlPaySuppliersNote: false,
  isShowSharedVehicleStockNote: false,
  style: BlTabStyle.Bluish,
};



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/biz-menu-page.const.ts